import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    // Handle page refresh and tab visibility changes
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Tab became visible, scroll to top
        window.scrollTo(0, 0);
      }
    };

    const handleBeforeUnload = () => {
      // Page is about to refresh, scroll to top
      window.scrollTo(0, 0);
    };

    // Listen for tab visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Listen for page refresh/reload
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup listeners
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null;
};

export default ScrollToTop;
